import {
	REQUEST_UPDATE_SETTINGS,
	REQUEST_UPDATE_SETTINGS_FAILURE,
	REQUEST_UPDATE_SETTINGS_SUCCESS,
} from './settings.actionTypes';

export const actionCreators = {
	doUpdateSettings: (key: string, settings: Object) => ({
		type: REQUEST_UPDATE_SETTINGS,
		settings,
		key,
	}),
	doUpdateSettingsSuccess: (key: string, settings: Object) => ({
		type: REQUEST_UPDATE_SETTINGS_SUCCESS,
		settings,
		key,
	}),
	doUpdateSettingsFailure: (error: Object) => ({
		type: REQUEST_UPDATE_SETTINGS_FAILURE,
		error,
	}),
};

export type SettingsActionType =
	| ReturnType<typeof actionCreators.doUpdateSettings>
	| ReturnType<typeof actionCreators.doUpdateSettingsSuccess>
	| ReturnType<typeof actionCreators.doUpdateSettingsFailure>;
